import { Route, Routes } from "react-router-dom";
import CommunityOnboardingStepOne from "./community-onboarding-step-one";
import CommunityOnboardingStepTwo from "./community-onboarding-step-two";

const CommunityOnboarding: React.FC<{}> = () => {
    return (
        <div className="h-full w-full">
            <Routes>
                <Route path="/" element={<CommunityOnboardingStepTwo />} />
                {/* <Route path="/1" element={< />} /> */}
            </Routes>
        </div>
    );
};

export default CommunityOnboarding;
//localhost:3000?web_invocation_type=CommunityOnBoarding
